import Admin from './Admin';
export default Admin;



// WEBPACK FOOTER //
// ./src/containers/Admin/index.js